import type { Abi, Address } from "viem"
import type { Config } from "wagmi"
import { routerAbi } from "@/domains/abis"
import { MinimalPoolStore } from "@/domains/minimal-pool"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type AddLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  minimalPool: MinimalPoolStore
  routerAddress: Address
  amountADesired: bigint
  amountBDesired: bigint
  amountAMin: bigint
  amountBMin: bigint
  deadline: number
}

export const addPairLiquidity = async ({
  account,
  chainId,
  config,
  minimalPool,
  routerAddress,
  amountADesired,
  amountBDesired,
  amountAMin,
  amountBMin,
  deadline,
}: AddLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: routerAbi as Abi,
        account,
        address: routerAddress,
        args: [
          minimalPool.token0.address.toViemAddress(),
          minimalPool.token1.address.toViemAddress(),
          minimalPool.isStable,
          amountADesired,
          amountBDesired,
          amountAMin,
          amountBMin,
          account,
          deadline,
        ],
        chainId,
        functionName: "addLiquidity",
      },
    })
    return result
  } catch (error: unknown) {
    console.error("addPairLiquidity", error)

    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
      code: error instanceof Error && "code" in error ? Number((error as { code: string }).code) : 0,
    }
  }
}
